import { type RootState } from '../rmsStore'

export default function getVersionReleasesReducer (state: RootState): VersionReleaseState {
  return state.versionReleasesReducer
}
